<template>
  <v-row class="align-center">
    <v-col cols="12" md="4"  FILTER v-for="(filter, f) in filters" :key="'filter-'+f" class="py-1">
      <FilterField 
        v-if="!filter.roles || filter.roles.includes(userRole)"
        :filter="filter"
        :index="f"
        :appliedFilters="appliedFilters"
        :loading="loading"
        :resource="resource"
      />
    </v-col>
  </v-row>
</template>

<script>
import FilterField from './FilterField.vue'
export default {
  components:{
    FilterField
  },
  props:['filters', 'appliedFilters', 'loading', 'resource'],
  computed:{
    userRole() {
      return this.$store.state.user.role;
    },
  }
}
</script>

<style>

</style>